import { FaberApi } from "api"

class PackageAPI {
  static getPackageDetails(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpGet(
      `/sim/ops/plan/package/${packageId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getExternalPackageDetails(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpGet(
      `/sim/ext/plan/package/${packageId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }


  static replacePackage(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpPost(
      `/sim/ops/esim/package/${packageId}/reset`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      // No data to be passed in
      // only allow resets if less than 100mb
      {
        ignoreUsage: false
      }
    )
  }

  static externalReplacePackage(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpPost(
      `/sim/ext/esim/package/${packageId}/reset`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      // No data to be passed in
      // only allow resets if less than 100mb
      {
        ignoreUsage: false
      }
    )
  }

  // Terminate is different as compared to replace because there is no data limit check
  // because we are not replacing a new pack for them
  static terminatePackage(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpPost(
      `/sim/ops/esim/package/${packageId}/terminate`,
      {
        Authorization: `Bearer ${faberToken}`
      },
    )
  }

  static externalTerminatePackage(
    packageId: string,
    faberToken: string
  ) {
    return FaberApi.httpPost(
      `/sim/ext/esim/package/${packageId}/terminate`,
      {
        Authorization: `Bearer ${faberToken}`
      },
    )
  }
}

export default PackageAPI
